// extracted by mini-css-extract-plugin
export default {"button":"secondaryButton_button__AawZ2"};